import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Plus, ArrowRight } from 'lucide-react';

interface AddMoreCategoriesStepProps {
  processedCategories: string[];
  onComplete: (action: 'add_more' | 'summary') => void;
}

export const AddMoreCategoriesStep = ({ 
  processedCategories, 
  onComplete 
}: AddMoreCategoriesStepProps) => {
  return (
    <div className="space-y-6 p-4">
      <div className="text-center">
        <h3 className="font-semibold text-lg mb-2">Catégories terminées</h3>
        <p className="text-muted-foreground">
          Souhaitez-vous **ajouter une autre catégorie** d'offres ou passer au récapitulatif ?
        </p>
      </div>

      {/* Catégories déjà traitées */}
      <div className="space-y-3">
        <h4 className="font-medium text-sm text-muted-foreground">Catégories déjà vues :</h4>
        <div className="flex flex-wrap gap-2">
          {processedCategories.map((category) => (
            <Badge key={category} variant="secondary" className="flex items-center gap-1">
              ✓ {category}
            </Badge>
          ))}
        </div>
      </div>

      {/* Actions */}
      <div className="space-y-3">
        <Button 
          onClick={() => onComplete('add_more')}
          className="w-full flex items-center justify-center gap-2"
          variant="outline"
        >
          <Plus className="w-4 h-4" />
          Ajouter une autre catégorie
        </Button>
        
        <Button 
          onClick={() => onComplete('summary')}
          className="w-full flex items-center justify-center gap-2"
        >
          <ArrowRight className="w-4 h-4" />
          Passer au récapitulatif final
        </Button>
      </div>

      <div className="text-center text-sm text-muted-foreground">
        Vous pourrez toujours modifier votre sélection dans le récapitulatif.
      </div>
    </div>
  );
};